angular.module('vastdesk').
  component('daypartingBulkEdit', {
    bindings: {
      initialDayParting: '<',
    },
    template: require('../templates/daypartingBulkEdit.html'),
    controllerAs: '$daypartingBulkEditCtrl',
    controller: [function() {
      this.dayPartingInputNameFor = function(day, hour) {
        return 'day_parting[' + day + '][' + hour + ']';
      };

      this.dayParting = Array.from({length: 7}, (_k, _day) => Array.from({length: 24}, (_k, _hour) => false));

      this.$onInit = function () {
        if (this.initialDayParting) {
          for (let day = 0; day < 7; ++day) {
            if (!Array.isArray(this.initialDayParting[day])) {
              continue;
            }
            for (let hour = 0; hour < 24; ++hour) {
              if (this.initialDayParting[day][hour]) {
                this.dayParting[day][hour] = true;
              }
            }
          }
        }
      };
    }],
  });
